import type { RouteComponentProps } from "react-router-dom"
import ProjectReportedHours from "../../../projects/components/ProjectReportedHours"
import { useProject } from "../../../projects/hooks/use-project"

type RouteParams = { projectId: string }

const queryOptions = { refetchOnMountOrArgChange: true } as const

const ProjectReportedHoursRoute = ({ match }: RouteComponentProps<RouteParams>) => {
  const { project } = useProject(match.params.projectId, queryOptions)

  if (!project) return null

  return <ProjectReportedHours project={project} />
}

export default ProjectReportedHoursRoute
